import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { exchangeStravaToken } from '../../services/systemService';
import COLORS from '../../utils/colors';
import { FaStrava, FaSpinner, FaExclamationTriangle } from 'react-icons/fa';

const StravaCallback: React.FC = () => {
  const [status, setStatus] = useState<'loading' | 'success' | 'error'>('loading');
  const [message, setMessage] = useState<string>('Đang xử lý xác thực Strava...');
  const [athleteName, setAthleteName] = useState<string | null>(null);
  
  const navigate = useNavigate();
  const location = useLocation();
  
  useEffect(() => {
    const processStravaCallback = async () => {
      try {
        // Lấy code từ URL
        const queryParams = new URLSearchParams(location.search);
        const code = queryParams.get('code');
        const scope = queryParams.get('scope');
        
        if (!code) {
          setStatus('error');
          setMessage('Không tìm thấy mã xác thực trong URL callback');
          return;
        }
        
        console.log('Đã nhận code từ Strava:', code);
        console.log('Scope được cấp quyền:', scope);
        
        // Gọi API để đổi code lấy token
        const tokenData = await exchangeStravaToken(code);
        
        // Lưu thông tin kết nối vào localStorage để dùng ở các màn hình khác
        localStorage.setItem('stravaConnected', 'true');
        if (tokenData.athleteName) {
          localStorage.setItem('stravaAthleteName', tokenData.athleteName);
        }
        
        // Cập nhật trạng thái thành công
        setStatus('success');
        setMessage('Đã kết nối thành công với Strava');
        setAthleteName(tokenData.athleteName);
        
        // Sau 2 giây, chuyển hướng về trang cài đặt
        setTimeout(() => {
          navigate('/settings', { 
            state: { stravaConnected: true, athleteName: tokenData.athleteName },
            replace: true  // Dùng replace: true để thay thế hoàn toàn URL hiện tại bằng URL mới
          });
        }, 2000);
      } catch (error: any) {
        console.error('Lỗi khi xử lý callback Strava:', error);
        setStatus('error');
        setMessage(error.message || 'Đã xảy ra lỗi khi xác thực với Strava');
        
        // Sau 3 giây, chuyển hướng về trang cài đặt với thông báo lỗi
        setTimeout(() => {
          navigate('/settings', { 
            state: { stravaError: true, errorMessage: error.message },
            replace: true // Dùng replace để thay thế URL hiện tại
          });
        }, 3000);
      }
    };
    
    processStravaCallback();
  }, [location, navigate]);
  
  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      height: '100vh',
      backgroundColor: COLORS.background.main,
      padding: '20px'
    }}>
      <div style={{
        backgroundColor: COLORS.background.dark,
        borderRadius: '12px',
        padding: '30px',
        width: '100%',
        maxWidth: '500px',
        textAlign: 'center',
        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)'
      }}>
        <div style={{ 
          fontSize: '72px', 
          color: status === 'success' ? '#FC5200' : 
                 status === 'error' ? COLORS.status.error : 
                 '#FC5200',
          marginBottom: '20px' 
        }}>
          {status === 'loading' && <FaSpinner style={{ animation: 'spin 1s linear infinite' }} />}
          {status === 'success' && <FaStrava />}
          {status === 'error' && <FaExclamationTriangle />}
        </div>
        
        <h2 style={{ 
          color: COLORS.text.light, 
          marginBottom: '16px',
          fontSize: '24px'
        }}>
          {status === 'loading' ? 'Đang xử lý...' : 
           status === 'success' ? 'Kết nối thành công!' : 
           'Kết nối thất bại'}
        </h2>
        
        <p style={{ 
          color: COLORS.text.medium,
          marginBottom: athleteName ? '16px' : '0',
          fontSize: '16px' 
        }}>
          {message}s
        </p>
        
        {athleteName && (
          <p style={{ 
            color: COLORS.text.light,
            fontWeight: 'bold',
            marginTop: '8px'
          }}>
            Người dùng: {athleteName}
          </p>
        )}
        
        <p style={{ 
          color: COLORS.text.medium,
          marginTop: '20px',
          fontSize: '14px' 
        }}>
          {status === 'loading' ? 'Vui lòng đợi trong giây lát...' : 
           'Bạn sẽ được chuyển hướng về trang cài đặt trong giây lát...'}
        </p>
      </div>
      
      <style>{`
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
};

export default StravaCallback; 